import type { JSX } from 'react';
import React from 'react';

import { Spinner } from '@feathr/components';

import * as styles from './PerchLoading.css';

/** Full-viewport centered spinner, shared by `PerchGate` and `PerchApp` so every Perch loading state looks the same. */
function PerchLoading(): JSX.Element {
  return (
    <div className={styles.loading}>
      <Spinner />
    </div>
  );
}

export default PerchLoading;
